const SET_WORKGROUP_LIST = 'SET_WORKGROUP_LIST';
const SET_WORKGROUP_NAMES = 'SET_WORKGROUP_NAMES';
const SET_WORKGROUP_ALL_TAGS = 'SET_WORKGROUP_ALL_TAGS';
const SET_WORKGROUP_SEARCH_ALL_DATA = 'SET_WORKGROUP_SEARCH_ALL_DATA';
const SET_WORKGROUP_SUBMIT_MSG = 'SET_WORKGROUP_SUBMIT_MSG';

export const MANAGE_WORKGROUP_ACTION_TYPES = {
    SET_WORKGROUP_LIST,
    SET_WORKGROUP_NAMES,
    SET_WORKGROUP_ALL_TAGS,
    SET_WORKGROUP_SEARCH_ALL_DATA,
    SET_WORKGROUP_SUBMIT_MSG,
};
